import {useFormik} from 'formik';
import React from 'react';
import {useNavigate} from 'react-router';
import * as Yup from 'yup';

import {useRequestPasswordResetMutation} from '@/api';

import {PositiveButton} from '../../../components/mypage/MypageLayout';
// @ts-ignore

export const validateSchema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .required('必須項目です')
    .email('メールアドレスの形式が不正です'),
});

const ResetPasswordForm = () => {
  const navigate = useNavigate();
  const [requestResetPassword, {data, loading}] =
    useRequestPasswordResetMutation({
      onCompleted: (data) => {
        if (!data?.requestPasswordReset?.error) {
          navigate('/reset_password/success');
        }
      },
    });

  const formik = useFormik({
    validationSchema: validateSchema,
    initialValues: {
      email: '',
    },
    onSubmit: (values) => {
      void requestResetPassword({variables: values});
    },
  });

  return (
    <div className="mx-auto w-[400px] pt-[90px] text-center">
      <h1 className="mb-[70px] text-center text-[26px] font-medium text-neutral-700">
        パスワードの再設定
      </h1>

      {data?.requestPasswordReset?.error && (
        <div className="mb-4 rounded border border-red-300 bg-red-50 p-3 text-sm text-red-700">
          <p>{data.requestPasswordReset.error}</p>
        </div>
      )}

      <div className="mb-10 mt-5 text-xs leading-[1.5] text-neutral-900 [&_p]:mb-0">
        <p>登録に利用したパスワードを入力してください。</p>
        <p>パスワードを再設定するためのメールをお送りします。</p>
      </div>

      <form onSubmit={formik.handleSubmit}>
        <div className="mb-[1em]">
          <label className="text-left text-xs opacity-[0.37] [color:#333333]">
            メールアドレス
          </label>
          <input
            name="email"
            type="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="block h-[45px] w-full border border-neutral-100 bg-neutral-100"
          />
          {formik.touched.email && formik.errors.email && (
            <p className="mt-1 text-left text-sm text-red-600">
              {formik.errors.email}
            </p>
          )}
        </div>

        <div className="my-[60px] [&_button]:w-full">
          <PositiveButton
            type="submit"
            size="large"
            disabled={loading || !formik.dirty || !formik.isValid}>
            送信
          </PositiveButton>
        </div>
      </form>
    </div>
  );
};

export {ResetPasswordForm};
